import Request from "@/common/net/request.js";
const request = new Request();
// 获取新司机列表
export function getNewDriverPage(params) {
  return request.send({
    url: `/pmy/sys/driver/news`,
    method: "get",
    params
  });
}
// 新司机订单情况
export function getOrderNewDriver(params) {
  return request.send({
    url: `/pmy/freight/order/freight/new-driver`,
    method: "get",
    params
  });
}
